import { SHOW_ERROR_PAGE } from '../types/shared';

// Initial State
export const model = {
  isShowingErrorPage: false,
  errorCode: null,
  initialData: {},
  appVersion: null,
  platform: '',
  searchQueryParams: {},
};

const sharedReducer = (state = model, { type, payload } = {}) => {
  if (type === SHOW_ERROR_PAGE) {
    return {
      ...state,
      isShowingErrorPage: true,
      errorCode: payload.errorCode,
    };
  }
  return state;
};

export default sharedReducer;
